"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStore = exports.debuggerDefaultStore = void 0;
var react_1 = require("react");
exports.debuggerDefaultStore = {
    debuggerProps: [],
    setDebuggerProp: function () { return ''; },
};
var DebuggerContext = (0, react_1.createContext)(exports.debuggerDefaultStore);
var useStore = function () { return (0, react_1.useContext)(DebuggerContext); };
exports.useStore = useStore;
exports.default = DebuggerContext;
//# sourceMappingURL=context.js.map